import React from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import Isvg from 'react-inlinesvg'

import Modalizer from 'components/modalizer/modalizer'
import SecondaryTitle from 'components/title_secondary/title_secondary'
import { MainButton } from 'components/button'
import TextLink from 'components/text_link/text_link'

import styles from './notification_modal.scss'

const NotificationModal = props => (
	<Modalizer
		closeAction={props.closeAction}
		closeButton={props.closeButton}
		nopadding={true}
	>
		<div styleName='container'>
			<section styleName='content-section'>
				<SecondaryTitle icon={props.alertIcon} isCentered={props.centeredTitle}>{props.alertTitle}</SecondaryTitle>
				<p styleName='text'>{props.alertMessage}</p>
				<Isvg src={props.imgIcon} cacheGetRequests={true} styleName='image' />
				<div styleName='button-container'>
					<MainButton focus={true} tabIndex={101} onClick={props.actionOne}>{props.btnOne}</MainButton>
				</div>
				<div styleName='link-container'>
					<TextLink color="grey" onClick={props.buttonDismissAction}>{props.buttonDismissText}</TextLink>
				</div>
			</section>
		</div>
	</Modalizer>
)

NotificationModal.defaultProps = {
	alertIcon: null,
	alertMessage: 'Default Message',
	alertTitle: 'Default Message',
	centeredTitle: false,
	closeButton: true,
	imgIcon: null,
	buttonDismissText: null,
}

NotificationModal.propTypes = {
	closeAction: PropTypes.func,
	closeButton: PropTypes.bool,
	alertIcon: PropTypes.node,
	centeredTitle: PropTypes.bool,
	alertTitle: PropTypes.string,
	alertMessage: PropTypes.string,
	actionOne: PropTypes.func,
	btnOne: PropTypes.string,
	imgIcon: PropTypes.node,
	buttonDismissText: PropTypes.string,
	buttonDismissAction: PropTypes.func,
}

export default CSSModules(NotificationModal, styles, {allowMultiple: true})
